import React from "react";
import FunctionHeader from "presentation/components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { TabPanel, TabView } from "primereact/tabview";
import { useAuthStore } from "presentation/stores/use-auth-store";
import MyEquipmentsTab from "presentation/components/Equipment/MyEquipmentsTab";
import AdminEquipmentsTab from "presentation/components/Equipment/AdminEquipmentsTab";

const EquipmentPage: React.FC = () => {
  const { isLoading } = usePermissionCheck({ requiredFunction: "equipments" });
  const { userPermissions } = useAuthStore();

  const isUserAdmin = (): boolean => {
    return userPermissions?.some((p) => p.role?.name === "Admin") ?? false;
  };

  if (isLoading) {
    return <Spinner />;
  }

  const isAdmin = isUserAdmin();

  return (
    <div>
      <FunctionHeader title="Gestão de Equipamentos" />
      <div className="card">
        <TabView>
          <TabPanel header="Meus Equipamentos" leftIcon="pi pi-desktop mr-2">
            <MyEquipmentsTab showOnlyVehicles={false} />
          </TabPanel>
          {isAdmin && (
            <TabPanel header="Gerir Equipamentos" leftIcon="pi pi-cog mr-2">
              <AdminEquipmentsTab showOnlyVehicles={false} />
            </TabPanel>
          )}
        </TabView>
      </div>
    </div>
  );
};

export default EquipmentPage;
